import { IBasicDataBudget } from "@interfaces/screens/basic-data-budget.interface";
import { Utilities, Enums, Dictionary, queryString, String, Constants } from "@utils";
import { useSelector } from "react-redux";
import { BasePresenter } from "@presenters/base/base.presenter";
import { IAEAColumnDefinition, IBudgetFormBasicDataMasters } from '@models/'

export interface ISelectItem {
    id: string,
    label: string
}
export interface IDataBudget {
    type?: any;
    exist?: boolean;
    country?: any;
    countryCode?: any;
    region?: any;
    year?: any;
    prTitle?: string;
    prNumber?: string;
    prCode?: string;
    IntLine?: any;
    suvCode?: any;
    nExpense?: any;
}
export class BasicDataBudgetPresenter extends BasePresenter<IBasicDataBudget> {
    public basicFields: Dictionary<string, IAEAColumnDefinition>;
    public detailFields: Dictionary<string, IAEAColumnDefinition>;
    public currentLabels: Dictionary<string, string>;
    public formMaster: IBudgetFormBasicDataMasters;
    private _basicBudgets: any[];
    public allBudgets: any;
    public currentBudget: any;
    public data: any;
    public currentField: any;
    public projectNumber: any;
    public budgetStatus: any
    public formSaveBudget: any;
    public statusCurrenBudget: any;

    constructor(view: IBasicDataBudget) {
        super(view);
        this.basicFields = useSelector(this.context.budgetStore.selectBasicDataColumns) as Dictionary<string, IAEAColumnDefinition>;
        this.formMaster = useSelector(this.context.budgetStore.selectFormMasters) as IBudgetFormBasicDataMasters;
        this._basicBudgets = useSelector(this.context.budgetStore.selectBasicBudgets) as any[];
        this.projectNumber = useSelector(this.context.budgetStore.selectProjectNumber) as any;
        this.currentBudget = useSelector(this.context.budgetStore.selectCurrentBudget);
        this.budgetStatus = useSelector(this.context.budgetStore.selectbudgetStatus) as any;
        this.formSaveBudget = useSelector(this.context.budgetStore.selectFormSaveBudget) as any;
        this.currentLabels = useSelector(this.context.sessionStore.selectLabels);
    }
    //#region public methods    
    public updateId() {
        const query = queryString.parseUrl(window.location.href.replace('#', '')).query as any;
        return query.Id;
    }
    public initializeBudgetType() {
        if (Utilities.isNullEmptyObject(this.currentBudget)) {
            this.inicializeCurrentBudget();
        } else {
            this.controlCurrentBudget();
        }
    }
    public initRender(): boolean {
        return (!Utilities.isNullObject(this.basicFields) &&
            !Utilities.isNullObject(this.formMaster) &&
            !Utilities.isNullObject(this.currentBudget));
    }
    public switchView() {
        const readOnly = window.location.href.indexOf("view?Id") > -1;
        const allowedEdit = window.location.href.indexOf("edit?Id") > -1;
        if (readOnly) { this.view.state.setReadOnly(true) }
        if (allowedEdit) { this.view.state.setAllowedEdit(true) }
    }
    public controlCurrentBudget() {
        const year = this.currentBudget.Year;
        const country = this.currentBudget.RegionCountry;
        const code = this.currentBudget.PPresCodProy;
        const number = this.currentBudget.PPresNumProy;

        const numberReset = (this.view.state.numberReset && !Utilities.isNullObject(year) && !Utilities.isNullObject(country));
        const createdCode = (Utilities.isNullObject(number) && Utilities.isNullObject(code) && !numberReset);
        const projectOn = (this.view.state.budgetType === Enums.SystemParameters.BudgetTypeOn);
        const newProject = (!this.view.state.exist && !this.view.state.readOnly && !this.view.state.allowedEdit);

        if (!projectOn && newProject && createdCode && year && country && this.projectNumber) {
            const countryCode = country[0].code.substring(0, 2);
            const yearCode = year[0].label.slice(-2);
            const numberCode = this.projectNumber.slice(-2);
            const _currentBudget: any = Utilities.copyObject(this.currentBudget) as any;
            _currentBudget.PPresCodProy = `${countryCode}${yearCode}${numberCode}`;
            _currentBudget.PPresNumProy = this.projectNumber;
            this.setBudgetStore(_currentBudget);
        }

        if (!projectOn && newProject && numberReset) {
            this.view.state.setNumberReset(false);
            const key = year[0].label + country[0].code;
            this.syncDispatcher(this.context.budgetStore.getProjectNumber(key));
        }

        if ((this.view.state.budgetType !== this.currentBudget.PPresTipoPresId) && !Utilities.isNullEmptyObject(this.currentBudget.PPresTipoPresId)) {
            this.view.state.setBudgetType(this.currentBudget.PPresTipoPresId)
        }
    }
    //#endregion    

    //#region Field Definition
    public get existField() {
        const field = {
            ...this.getCommonFieldProps("Existe"),
            onValueChanged: this.onChangeExistProject,
            value: this.view.state.exist,
            showTooltip: false,
            fieldType: Enums.FieldTypes.Checkbox,
            readOnly: (this.view.state.readOnly || this.view.state.budgetType === Enums.SystemParameters.BudgetTypeOn)
        };
        return field;
    }
    public get budgetTypeField() {
        const field = {
            ...this.getCommonFieldSelectProps("Tipo Presupuesto"),
            value: this.view.state.budgetType,
            fieldType: Enums.FieldTypes.Radio,
            layout: 'horizontal',
            onValueChanged: this.onChangeProjectType,
            showLabel: false,
            readOnly: (this.view.state.readOnly || this.view.state.allowedEdit || this.view.state.exist)
        };
        return field;
    }
    public get yearField() {
        const _properties: any = this.getCommonFieldSelectProps(Enums.BudgetBasicFields.Year);
        const readOnly = (this.view.state.readOnly ||
            (this.view.state.exist && Utilities.isNullEmptyObject(this.currentBudget.PPresCodProy)) ||
            (this.view.state.budgetType === Enums.SystemParameters.BudgetTypeOn && Utilities.isNullEmptyObject(this.currentBudget.RegionCountry)) ||
            (this.view.state.budgetType === Enums.SystemParameters.BudgetTypeOn && this.view.state.allowedEdit)
        );
        const field = {
            ..._properties,
            readOnly: readOnly,
            value: this.currentBudget.Year,
            fieldType: Enums.FieldTypes.Select,
            onValueChanged: this.onChangeYear
        };
        return field;
    }
    public get regionCountryField() {
        const _properties: any = this.getCommonFieldSelectProps(Enums.BudgetBasicFields.Country);
        const readOnly = (
            (this.view.state.allowedEdit || this.view.state.readOnly) ||
            (this.view.state.exist) ||
            (this.view.state.budgetType === Enums.SystemParameters.BudgetTypeOn && !Utilities.isNullEmptyObject(this.currentBudget.Year))
        );
        const field = {
            ..._properties,
            readOnly: readOnly,
            value: this.currentBudget.RegionCountry,
            fieldType: Enums.FieldTypes.Select,
            onValueChanged: this.onChangeRegionCountry
        };
        return field;
    }
    public get titleField() {
        const readOnly = (this.view.state.readOnly);
        const field = {
            ...this.getCommonFieldSelectProps(Enums.BudgetBasicFields.PrTitle),
            readOnly: readOnly,
            fieldType: Enums.FieldTypes.Textarea,
            value: this.currentBudget.Title,
            onValueChanged: (value: any) => {
                this.setCurrentBudgetItem("Title", value);
            }
        };
        return field;
    }
    public get projectNumberField() {
        const field = {
            ...this.getCommonFieldSelectProps(Enums.BudgetBasicFields.PrNumber),
            fieldType: Enums.FieldTypes.Text,
            value: this.currentBudget.PPresNumProy || "",
            readOnly: true
        };
        return field;
    }
    public get projectCodeTextField() {
        const _properties: any = this.getCommonFieldSelectProps(Enums.BudgetBasicFields.PrCode);
        const field = {
            ..._properties,
            value: this.currentBudget.PPresCodProy,
            fieldType: Enums.FieldTypes.Text,
            readOnly: true
        };
        return field;
    }
    public get projectCodeSelectField() {
        const _properties: any = this.getCommonFieldSelectProps(Enums.BudgetBasicFields.PrCode);
        const field = {
            ..._properties,
            value: this.currentBudget.PPresCodProyAux,
            fieldType: Enums.FieldTypes.Select,
            readOnly: false,
            onValueChanged: this.onChangeProjectCode
        };
        return field;
    }
    public get interventionLineField() {
        const _properties: any = this.getCommonFieldSelectProps(Enums.BudgetBasicFields.IntLine);
        const field = {
            ..._properties,
            readOnly: this.view.state.readOnly,
            value: this.currentBudget.LineaIntervencionId,
            fieldType: Enums.FieldTypes.Select,
            onValueChanged: this.onChangeInterventionLine
        };
        return field;
    }
    //#endregion Field Definition


    //#region  Field Actions
    private onChangeProjectType = (value: any) => {
        this.inicializeCurrentBudget(value);
    }
    private onChangeExistProject = (value: any) => {
        this.view.state.setProjectExist(value);
        if (value) { this.view.state.setNumberReset(false) }
        this.inicializeCurrentBudget();
    }
    private onChangeYear = (value: any[]) => {
        const _currentBudget: any = Utilities.copyObject(this.currentBudget) as any;
        const years = this.getCommonFieldSelectProps(Enums.BudgetBasicFields.Year).items
        const year = years.filter(x => x.id === value[0]);

        if (!this.view.state.allowedEdit) {
            if (Utilities.isEmptyObject(year)) {
                _currentBudget.Year = null;
            } else {
                _currentBudget.Year = year;
            }
            if (!this.view.state.exist) {
                _currentBudget.PPresCodProy = null;
                _currentBudget.PPresNumProy = null;
            }
            this.view.state.setNumberReset(true);
        } else {
            if (!Utilities.isEmptyObject(year)) {
                _currentBudget.Year = year;
            }
        }

        this.setBudgetStore(_currentBudget);
    }
    private onChangeRegionCountry = (value: any[]) => {
        const _currentBudget: any = Utilities.copyObject(this.currentBudget) as any;
        const countryList = this.getCommonFieldSelectProps(Enums.BudgetBasicFields.Country).items;
        const country = countryList.filter(x => x.id === value[0]);
        if (Utilities.isEmptyObject(country)) {
            _currentBudget.RegionCountry = null;
        } else {
            _currentBudget.RegionCountry = country;
        }
        _currentBudget.PPresCodProy = null;
        _currentBudget.PPresNumProy = null;
        this.view.state.setNumberReset(true);
        this.setBudgetStore(_currentBudget);
    }
    private onChangeProjectCode = (value: any[]) => {
        const _currentBudget: any = {};
        const basicBudget = this._basicBudgets.find(_basicBudget => _basicBudget.Id === value[0]);
        if (!Utilities.isNullEmptyObject(basicBudget)) {
            const countryRegion: any = {};
            _currentBudget.PPresPresupuestoId = basicBudget.Id;
            _currentBudget.PPresTipoPresId = this.view.state.budgetType;
            _currentBudget.Year = null;

            if (!Utilities.isNullEmptyObject(basicBudget.OCTAVIARegionId)) {
                const region = this.regions.find(x => x.Id === basicBudget.OCTAVIARegionId);
                countryRegion.id = String.Format('{0}{1}', Constants.Globals.PREFFIX_RG, region.Id);
                countryRegion.label = region.Title;
                countryRegion.code = region.OCTAVIACodigo;
            } else {
                const country = this.countries.find(x => x.Id === basicBudget.OCTAVIAPaisId);
                countryRegion.id = country.Id;
                countryRegion.label = country.Title;
                countryRegion.code = country.OCTAVIACodigo;
            }

            _currentBudget.RegionCountry = [countryRegion];
            _currentBudget.Title = basicBudget.Title;
            _currentBudget.PPresNumProy = basicBudget.PPresNumProy;
            _currentBudget.PPresCodProyAux = [{ id: value[0], label: basicBudget.CodigoProyecto?.Title, code: "" }];
            _currentBudget.PPresCodProy = basicBudget.CodigoProyecto?.Title;

            const interventionLine = this.interventionLines.find(x => x.Id === basicBudget.OCTAVIALineaIntervencionId)
            _currentBudget.LineaIntervencionId = [{ id: interventionLine.Id, label: interventionLine.Title, code: "" }];

            _currentBudget.projectExists = this.view.state.exist ?? false;

            this.setBudgetStore(_currentBudget);
        } else {
            this.inicializeCurrentBudget();
        }
    }
    private onChangeInterventionLine = (value: any) => {
        const _currentBudget: any = Utilities.copyObject(this.currentBudget) as any;
        const lines = this.getCommonFieldSelectProps(Enums.BudgetBasicFields.IntLine).items
        const line = lines.filter(x => x.id === value[0]);
        if (line.length > 0) {
            _currentBudget.LineaIntervencionId = line;
        } else {
            _currentBudget.LineaIntervencionId = null;
        }
        this.setBudgetStore(_currentBudget);
    }
    //#endregion

    //#region Private Methods
    private inicializeCurrentBudget(budgetType?: number, projectExist?: boolean) {
        const _currentBudget: any = {};
        _currentBudget.Year = null;
        _currentBudget.RegionCountry = null;
        _currentBudget.Title = null;
        _currentBudget.PPresNumProy = null;
        _currentBudget.PPresCodProy = null;
        _currentBudget.PPresCodProyAux = null;
        _currentBudget.LineaIntervencionId = null;
        _currentBudget.PPresTipoPresId = budgetType ? budgetType : this.view.state.budgetType;
        _currentBudget.projectExists = projectExist ? projectExist : false;
        this.setBudgetStore(_currentBudget);
    }

    private getCommonFieldProps(fieldName: string) {
        const fieldProps = this.basicFields.get(fieldName);
        return {
            showLabel: true,
            title: fieldProps.NombreColumna,
            description: fieldProps.OCTAVIATooltip,
            id: "bg_" + fieldProps.Id,
            placeholder: fieldProps.NombreColumna,
            fieldType: fieldProps.TipoCampoProyecta,
            requiredErrorMessage: "campo obligatorio",
            required: true
        }
    }

    private getCommonFieldSelectProps(fieldName: string) {
        const field = {
            ...this.getCommonFieldProps(fieldName),
            items: this.getItems(fieldName)
        };
        return field;
    }
    private getItems(fieldName: string): ISelectItem[] {
        let result: any = [];
        if (!Utilities.isNullObject(this.formMaster)) {
            switch (fieldName) {
                case Enums.BudgetBasicFields.Type:
                    result = this.convertToSelectItems(this.budgetTypes);
                    break;
                case Enums.BudgetBasicFields.Year:
                    result = this.convertToSelectItems(this.years);
                    break;
                case Enums.BudgetBasicFields.IntLine:
                    result = this.convertToSelectItems(this.interventionLines, undefined, undefined, undefined, "OCTAVIACodigo");
                    break;
                case Enums.BudgetBasicFields.PrCode:
                    const basicBudgets = this.basicBudgets.filter(x => x.PPresPresupuestoId === null && x.PPresTipoPresId !== Enums.SystemParameters.BudgetTypeOn);
                    result = this.convertToSelectItems(basicBudgets, undefined, undefined, undefined, "PPresPresupuestoId", true);
                    break
                case Enums.BudgetBasicFields.Country: {
                    const data = this.convertToSelectItems(this.countries, undefined, undefined, undefined, "OCTAVIACodigo");
                    const dataR = this.convertToSelectItems(this.regions, undefined, undefined, Constants.Globals.PREFFIX_RG, "OCTAVIACodigo");
                    result = [...data, ...dataR];
                    break;
                }

            }
        }
        return result;
    }
    private setCurrentBudgetItem(itemName: string, value: any) {
        const _currentBudget = Utilities.copyObject(this.currentBudget) as any;
        _currentBudget[itemName] = value;
        this.setBudgetStore(_currentBudget);
    }
    private setBudgetStore = (_currentBudget: any) => {
        this.syncDispatcher(this.context.budgetStore.actions.setCurrentBudget(_currentBudget));
    }
    //#endregion

    //#region Budget Master
    private get basicBudgets(): any[] {
        if (!Utilities.isNullObject(this._basicBudgets)) {
            return this._basicBudgets.filter(x => x.PPresTipoPresId === this.view.state.budgetType);
        }
        return [];
    }
    private get years(): any[] {
        let result = [];
        if (!Utilities.isNullObject(this.formMaster)) {
            result = this.formMaster.years;
            const _currentBudget = this.currentBudget;

            if (this.view.state.exist && !Utilities.isNullEmptyObject(_currentBudget.PPresCodProyAux)) {
                const PPresCodProy = _currentBudget.PPresCodProyAux[0].label;
                const _basicBudgets = this.basicBudgets.filter(x => x.CodigoProyecto?.Title === PPresCodProy);
                result = this.formMaster.years.filter((data: any) => {
                    return _basicBudgets.filter(x => x.PPresAnioId === data.Id).length === 0;
                });
            }
            if (this.view.state.allowedEdit) {
                const PPresCodProy = _currentBudget.PPresCodProy;
                const _basicBudgets = this.basicBudgets.filter(x => x.CodigoProyecto?.Title === PPresCodProy);
                result = this.formMaster.years.filter((data: any) => {
                    return _basicBudgets.filter(x => x.PPresAnioId === data.Id).length === 0;
                });
            }
            if (this.view.state.budgetType === Enums.SystemParameters.BudgetTypeOn && !Utilities.isNullEmptyObject(_currentBudget.RegionCountry)) {

                const _onBudgets = this.basicBudgets.filter(x => x.PPresTipoPresId === this.view.state.budgetType);
                const _value = this.currentBudget.RegionCountry[0].id;
                let _basicBudgets: any = [];
                if (_value.toString().indexOf(Constants.Globals.PREFFIX_RG) !== -1) {
                    const _regionId = parseInt(_value.replace(Constants.Globals.PREFFIX_RG, ''));
                    _basicBudgets = _onBudgets.filter(x => x.OCTAVIARegionId === _regionId);
                } else {
                    _basicBudgets = _onBudgets.filter(x => x.OCTAVIAPaisId === _value);
                }
                result = this.formMaster.years.filter((data: any) => {
                    let exist = !_basicBudgets.find((x: any) => x.PPresAnioId === data.Id)
                    if(exist) return data
                });
            }
        }
        return result;
    }
    public get budgetType() {
        if (!Utilities.isNullObject(this.currentBudget)) {
            return this.currentBudget["PPresTipoPresId"];
        } else {
            return null;
        }

    }
    private get countries(): any[] {
        if (!Utilities.isNullObject(this.formMaster)) {
            return this.formMaster.countries;
        }
        return [];
    }
    private get regions(): any[] {
        if (!Utilities.isNullObject(this.formMaster)) {
            return this.formMaster.regions;
        }
        return [];
    }
    private get budgetTypes(): any[] {
        if (!Utilities.isNullObject(this.formMaster)) {
            return this.formMaster.budgetTypes;
        }
        return [];
    }
    private get interventionLines(): any[] {
        if (!Utilities.isNullObject(this.formMaster)) {
            return this.formMaster.interventionLines;
        }
        return [];
    }
    private convertToSelectItems(items: any[], keyField: string = "Id", labelField: string = "Title", preffix: string = "", code: string = "", isObjectSpecial:boolean = false) {
        let keyArray: string[] = [];
        let result: any[] = []
        items.map(item => {
            let _id = String.IsNullOrWhiteSpace(preffix) ? item[keyField] : preffix + item[keyField];
            if (keyArray.indexOf(_id) === -1) {
                keyArray.push(_id);
                result.push({
                    id: _id,
                    label: isObjectSpecial ? item["CodigoProyecto"] ? item["CodigoProyecto"]["Title"] : undefined : item[labelField],
                    code: String.IsNullOrWhiteSpace(code) ? "" : item[code]
                })
            }
        });
        return result;
    }

    //#endregion
}